import { rdrRequests, rdRequests, authorizedRDRequests } from "../httpRequest";

const settingsRequest = {
    loadEnterprise: (domain: string) => rdRequests.get(`webaccesscustomer/load/enterprise?domainUrl=${domain}`),
    getWebMenu: () => rdrRequests.get('search/popular/WebMenu'),
    getWebSiteSettings: () => rdrRequests.get('enterprise/websitesettings'),
    getConfigMessage: () => rdrRequests.get('search/popular/DynamicConfigMessage'),
    getEnterpriseSetting: () => rdrRequests.get('enterprise/settings'),
    getFutureBookingStartsEndsDates: (requestData: any) => rdRequests.post('webaccessfacility/futurebookingstartsendsdates', requestData),
    getWebSecuritySettings: () => rdRequests.get(`webaccesscustomer/load/websitesecuritysettings`),
    getContactUsSubject: () => rdRequests.get(`webaccesscustomer/ContactUsSubjects`),
    submitContactUs: (requestData: any) => rdRequests.post('webaccesscustomer/Send/ContactUsEmail', requestData),
    checkAuthorizeLogin: () => authorizedRDRequests.post('webaccesscustomer/check/authorizelogin', {}),
    getCMSPageContent: (pageName:string) => rdRequests.get(`webaccesscustomer/GetCMSContentDetail?pageName=${pageName}`),
    getContactUsPlaceInfo: (isVolunteer: boolean) => rdRequests.get(`webaccesscustomer/GetContactUsParkPlaceInfo?isVolunteer=${isVolunteer}`)
}

export default settingsRequest;